import { Component, OnDestroy, OnInit } from '@angular/core';
import { StateComponent } from '../state-component.interface';
import { Subscription } from 'rxjs';
import { Usdm2Service } from '../../../../services/ai/usdm2.service';
import { McpService } from '../../../../services/mcp.service';


type SoAData = {
  pages: number[];
}

@Component({
  selector: 'app-soa-tables',
  imports: [],
  templateUrl: './soa-tables.component.html',
  styleUrl: './soa-tables.component.css'
})
export class SoaTablesComponent implements StateComponent, OnInit, OnDestroy {
  stateName = 'Find SOA Tables';
  private usdmSub: Subscription | null = null;
  // eslint-disable-next-line
  data: SoAData | null = null;

  constructor(
    private usdm: Usdm2Service,
    private mcp: McpService,
  ) { }

  ngOnInit(): void {
    this.usdmSub = this.usdm.contentUpdate$.subscribe(async (item) => {
      console.log("Item received in SoaTablesComponent:", item);
      if (this.usdm.currentState() == this.stateName && item && item.type === 'FinishResponse') {
        // eslint-disable-next-line
        this.data = item.result as SoAData;
        let tables = '';
        for (const page of this.data.pages) {
          console.log('Fetching tables for page:', page);
          const tableResponse = await this.mcp.callMcpToolRaw('pdf_get_tables', { filepath: this.usdm.protocol?.path, page_num: page })
          let table = "";
          for (const content of tableResponse.content) {
            table += content.text + '\n';
          }
          tables += `Page: ${page}\n${table}\n\n`;
        }
        this.usdm.soaTables = tables;
        console.log(`Tables extraction process completed.\n\n${this.usdm.soaTables}`);
        this.usdm.signalStateCompletion(this.stateName);
      }
    });
  }

  ngOnDestroy(): void {
    this.usdmSub?.unsubscribe();
    this.usdmSub = null;
  }


}
